module.exports = __webpack_public_path__ + "img/zoom-out.2ef6c777.svg";